import React from 'react';
import { Chevron } from '~/assets/svg';
import './styles.scss';

class AccordionItem extends React.Component {

	constructor(props){
		super(props);
		this.state = {isOpen: true};
	}
	
	toggleCollapse() {
		console.log(this.state);
		this.setState({isOpen: !this.state.isOpen});
	}

	render () {
		return <div className={"accordion-item " + (this.state.isOpen ? '' : 'collapsed')}>
			<h1 onClick={this.toggleCollapse.bind(this)}>{this.props.title}<Chevron className="accordion-chevron"/></h1>
			<div className="accordion-content">{this.props.children}</div>
		</div>
	};
}

export default AccordionItem;